module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item"
  }, [_c('v-layout', {
    staticClass: "before-footer-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container')], 1), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "background-color": "#d5e14d"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "hidden-sm-down": ""
    }
  }, [_c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("INDUSTRIES IN GEORGIA")]), _vm._v(" "), _c('v-flex', [_c('ul', {
    staticClass: "industry-item"
  }, _vm._l((_vm.industries), function(industry, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": industry.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(industry.name))])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "hidden-sm-down": ""
    }
  }, [_c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("COMPETITIVE ADVANTAGE")]), _vm._v(" "), _vm._l((_vm.competitiveAdvantages), function(advantage, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": advantage.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(advantage.name))])
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-flex-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("BUSINESS RESOURCES")]), _vm._v(" "), _vm._l((_vm.businessResources), function(resource, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": resource.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(resource.name))])
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "social-media-footer column",
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md-12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md-12": ""
    }
  }, [_c('h3', [_vm._v("CONNECT WITH US")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-email")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-facebook-box")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-youtube-play")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-rss")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-flex-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "contact-us column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("CONTACT US")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.georgia.org/about-us/contact-us/"
    }
  }, [_vm._v("Use our Contact form")]), _vm._v(" "), _c('p', [_vm._v("Call us at +1-404-962-4000")]), _vm._v(" "), _c('p', [_vm._v("+1-800-255-0056 for the hearing impaired")]), _vm._v(" "), _c('p', [_vm._v("Georgia Department of Economic Development")]), _vm._v(" "), _c('p', [_vm._v("Technology Square, 75 5th Street N.W., Suite 1200 Atlanta, GA 30308")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-layout-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "site-map site-map-divider",
    attrs: {
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "site-map-column"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/footer-we_speak_business.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.georgia.org/sitemap",
      "target": "blank"
    }
  }, [_vm._v("Site Map")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.exploregeorgia.org/?_ga=2.117864841.1812343620.1523235297-576062532.1522934539",
      "target": "blank"
    }
  }, [_vm._v("ExploreGeorgia.org")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gaarts.org/",
      "target": "blank"
    }
  }, [_vm._v("GaArts.org")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://siteselector.georgia.org/?_ga=2.117864841.1812343620.1523235297-576062532.1522934539",
      "target": "blank"
    }
  }, [_vm._v("GeorgiaSiteSelector")])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-layout-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "footer-copyright",
    attrs: {
      "md12": ""
    }
  }, [_c('p', [_vm._v("© " + _vm._s(_vm.year) + " Georgia Department of Economic Development. All Rights Reserved.")]), _vm._v(" "), _c('p', [_vm._v("GDEcD is an equal opportunity employer.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/footer-logo.png"
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9ce9c7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteFooter.vue
// module id = 878
// module chunks = 13 19 20 21 22 25 26 27 32